import { CAT_EVENT_TYPES } from '@/app/utils/Collections';

export default {
  category: CAT_EVENT_TYPES,
  filters: [],
  useStrictSearch: false,
  searchBarProp: 'translations.name',
};
